import { datadogRum } from '@datadog/browser-rum';
import { analytics } from '@modules/analytics';
import { CARD_PAGE_VIEWER_ID_KEY, cookieHostname } from '@modules/analytics/helpers';

import { CookieConsentCategories } from '@modules/cookie-utils';
import { deleteCookie } from 'cookies-next';

import { useEffect } from 'react';

/** Extend this to handle other performance based cookies from tools that we use. */
const handlePerformanceCookiesConsent = (
  accepted: CookieConsentCategories[],
  rejected: CookieConsentCategories[]
) => {
  if (accepted.includes('performance')) {
    datadogRum.setTrackingConsent('granted');
  }

  if (rejected.includes('performance')) {
    datadogRum.setTrackingConsent('not-granted');
  }
};

/** Extend this to handle other analytics based cookies from tools that we use. */
const handleAnalyticsCookies = (accepted: CookieConsentCategories[], rejected: CookieConsentCategories[]) => {
  if (accepted.includes('analytics')) {
    analytics.initialize();
  }

  if (rejected.includes('analytics')) {
    // delete blinq_viewer_id cookie if analytics is rejected
    deleteCookie(CARD_PAGE_VIEWER_ID_KEY, { domain: cookieHostname() });

    analytics.reset();
  }
};

const handleCookieConsent = (
  event: CustomEvent<{
    accepted: CookieConsentCategories[];
    rejected: CookieConsentCategories[];
  }>
) => {
  const { accepted, rejected } = event.detail;

  handlePerformanceCookiesConsent(accepted, rejected);
  handleAnalyticsCookies(accepted, rejected);
};

export const useCookieConsentListener = (): void => {
  useEffect(() => {
    document.addEventListener('cookieyes_consent_update', handleCookieConsent as EventListener);

    return () => {
      document.removeEventListener('cookieyes_consent_update', handleCookieConsent as EventListener);
    };
  }, []);
};
